function check_useragent(useragent) {
    let _tablet = [
        /ipad|tablet|(android(?!.*mobile))/,
        /(windows(?!.*phone)(.*touch))/,
        /kindle/,
        /playbook/,
        /silk/,
        /(puffin(?!.*(IP|AP|WP)))/,
    ]
        .map(r => r.source)
        .join('|');
    let tablet = new RegExp(`(${_tablet})`);

    let _phone = [
        /mobi/,
        /ipod/,
        /phone/,
        /blackberry/,
        /opera mini/,
        /fennec/,
        /minimo/,
        /symbian/,
        /psp/,
        /nintendo ds/,
        /archos/,
        /skyfire/,
        /puffin/,
        /blazer/,
        /bolt/,
        /gobrowser/,
        /iris/,
        /maemo/,
        /semc/,
        /teashark/,
        /uzard/,
    ]
        .map(r => r.source)
        .join('|');
    let phone = new RegExp(`(${_phone})`);

    if (tablet.test(useragent)) {
        return 'tablet';
    } else if (phone.test(useragent)) {
        return 'phone';
    } else {
        return 'desktop';
    }
}

export function detect_device(useragent) {
    let ua = useragent.toLowerCase();
    let device = check_useragent(ua);

    let ret = {
        device: device,
        detect: check_useragent,
        isMobile: device !== 'desktop' ? true : false,
        userAgent: ua,
    };
    return ret;
}
